import { useContext, createContext } from "react";

export const PollContext = createContext(null);

export function usePollContext() {
  return useContext(PollContext);
}
